import { render, staticRenderFns } from "./CanvasText.vue?vue&type=template&id=47da0e86&scoped=true"
import script from "./CanvasText.vue?vue&type=script&lang=js"
export * from "./CanvasText.vue?vue&type=script&lang=js"
import style0 from "./CanvasText.vue?vue&type=style&index=0&id=47da0e86&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47da0e86",
  null
  
)

export default component.exports